// LSG
import searchAugment from './search-augment'

import LocalNav from 'ont-styleguide/src/lsg/layout/navigation_local'
import SubNav from 'ont-styleguide/src/lsg/layout/sub_nav'
import TabbedOverlay from 'ont-styleguide/src/lsg/layout/tabbed_overlay'


// must make sure we init search before tabs panel (in layout)
const Search = require('ont-styleguide/src/lsg/components/search');
let searches = Search($('.search[id]'));

LocalNav(document.getElementsByClassName('js-nav'))
SubNav()
TabbedOverlay()

export const LsgLayout = {
  LocalNav: LocalNav,
  SubNav: SubNav,
  TabbedOverlay: TabbedOverlay,
}

import(/* webpackChunkName: "lsg-components" */ 'ont-styleguide/dist/components').then(({ default: LsgComps }) => {
  // load lsg components asynchronously to improve initial load time
  window.lsgPublicApi = window.lsgPublicApi || {}
  window.lsgPublicApi.components = LsgComps

  var searches = LsgComps.Search($('.search[id="mainSearch"], .search[id="faqSearch"], .search[id="protocolSearch"], .search[id="guestSearch"]'));
  searchAugment(searches['mainSearch'], searches['faqSearch'], searches['protocolSearch'], searches['guestSearch']);

  $('.tabbed-overlay--right').on('open', function() {
    $('.tabbed-overlay__secondary-panel .search__filters').trigger('filtersUpdated');
  });

  window.modal = LsgComps.Modals();
});
